import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'tk-vehicle-list-full-inidicator-status-header',
    templateUrl: './vehicle-list-full-indicator-status-header.component.html',
    styleUrls: ['./vehicle-list-full-indicator-status-header.component.less']
})
export class VehicleListFullIndicatorStatusHeaderComponent {
    @Output()
    public onStatusChanged: EventEmitter<any> = new EventEmitter();

    @Input()
    public currentValue = 'all';

    public isPanelVisible = false;

    private timeOut: any;

    onSelect(val: string) {
        this.currentValue = val;
        this.onStatusChanged.emit(val);
        this.isPanelVisible = false;
    }

    showPanel(flag: boolean) {
        if (flag === true) {
            this.isPanelVisible = true;
            if (this.timeOut) {
                clearTimeout(this.timeOut);
            }
        } else {
            this.timeOut = setTimeout(() => this.isPanelVisible = false, 300);
        }
    }
}
